import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/User';


@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  user: User;

  constructor() { }

  ngOnInit() {
    this.user = <User>JSON.parse(localStorage.getItem('user'));
  }

}
